import forEachElement from '../selectors/forEachElement';

export default function addEventListeners(elements, events, callback) {
  if(typeof(events) === 'string') {
    events = events.split(/\s+/);
  }

  forEachElement(elements, function(element) {
    events.forEach(function (event) {
      element.addEventListener(event, callback);
    });
  });
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/events/addEventListeners.js